import { CommonModule } from '@angular/common';
import { Component, Host, NgModule, OnInit, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { HideParentIfEmptyDirective, HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LinkModule } from '@app/directives/link.directive';
import { ChannelService } from '@app/services/channel.service';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { PageModule } from '@app/views/pages/page/page.component';
import { PagesViewModule } from '@app/views/pages/pages-view.module';
import { FilterButtonInfo } from '@app/models/filter-button-info';

@Component({
  selector: 'app-filter-by-department',
  templateUrl: './filter-by-department.component.html',
  styleUrls: ['./filter-by-department.component.scss']
})
export class FilterByDepartmentComponent implements OnInit {
  definedChannels: Array<FilterButtonInfo>;
  showComponent: boolean;
  channels$: Observable<Array<FilterButtonInfo>>;
  newsFilterButtons = this.featureSettingsStoreService.state.newsFilterButtonConfig;

  constructor(private featureSettingsStoreService: FeatureSettingsStoreService,
              private router: Router,
              @Host() @Optional() private hideParentIfEmptyDirective: HideParentIfEmptyDirective,
              private channelService: ChannelService) {
  }

  ngOnInit(): void {
    this.showComponent = this.featureSettingsStoreService.state.showFilterByDepartmentButtons;
    this.definedChannels = this.newsFilterButtons;
    if (this.showComponent && this.definedChannels && this.definedChannels.length > 0) {
      this.hideParentIfEmptyDirective && this.hideParentIfEmptyDirective.showElement();
      this.channels$ =
        this.channelService.getChannels()
          .pipe(
            map(channels => {
              // Modify channels for selection (recursively)
              channels = channels.flattenRecursive('Terms');
              this.definedChannels = this.definedChannels.filter(r => channels.map(c => c.Guid).indexOf(r.GUID) >= 0);
              this.definedChannels.sort((a, b) => a.SortOrder - b.SortOrder);

              if (this.definedChannels.length < 1) {
                this.hideParentIfEmptyDirective && this.hideParentIfEmptyDirective.hideElement();
              }
              return this.definedChannels;
            }));
    } else {
      this.hideParentIfEmptyDirective && this.hideParentIfEmptyDirective.hideElement();
    }
  }

}
@NgModule({
  declarations: [FilterByDepartmentComponent],
  exports: [
    FilterByDepartmentComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    LinkModule,
    PageModule,
    PagesViewModule,
    RouterModule,
    HideParentIfEmptyModule
  ]
})
export class FilterByDepartmentModule { }
